export const countryState = {
  US: [
    { code: 'AK', name: 'Alaska' },
    { code: 'AL', name: 'Alabama' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DC', name: 'Washington DC' },
    { code: 'DE', name: 'Delaware' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'IA', name: 'Iowa' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MD', name: 'Maryland' },
    { code: 'ME', name: 'Maine' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MT', name: 'Montana' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NY', name: 'New York' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VA', name: 'Virginia' },
    { code: 'VT', name: 'Vermont' },
    { code: 'WA', name: 'Washington' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WY', name: 'Wyoming' }
  ],
  CA: [
    { code: 'AB', name: 'Alberta' },
    { code: 'BC', name: 'British Columbia' },
    { code: 'MB', name: 'Manitoba' },
    { code: 'NB', name: 'New Brunswick' },
    { code: 'NL', name: 'Newfoundland and Labrador' },
    { code: 'NS', name: 'Nova Scotia' },
    { code: 'NT', name: 'Northwest Territories' },
    { code: 'NU', name: 'Nunavut' },
    { code: 'ON', name: 'Ontario' },
    { code: 'PE', name: 'Prince Edward Island' },
    { code: 'QC', name: 'Quebec' },
    { code: 'SK', name: 'Saskatchewan' },
    { code: 'YT', name: 'Yukon' }
  ],
  IT: [
    { code : 'AG' , name : 'Agrigento' },
    { code : 'AL' , name : 'Alessandria' },
    { code : 'AN' , name : 'Ancona' },
    { code : 'AO' , name : 'Aosta' },
    { code : 'AR' , name : 'Arezzo' },
    { code : 'AP' , name : 'Ascoli Piceno' },
    { code : 'AT' , name : 'Asti' },
    { code : 'AV' , name : 'Avellino' },
    { code : 'BA' , name : 'Bari' },
    { code : 'BT' , name : 'Barletta-Andria-Trani' },
    { code : 'BL' , name : 'Belluno' },
    { code : 'BN' , name : 'Benevento' },
    { code : 'BG' , name : 'Bergamo' },
    { code : 'BI' , name : 'Biella' },
    { code : 'BO' , name : 'Bologna' },
    { code : 'BZ' , name : 'Bolzano' },
    { code : 'BS' , name : 'Brescia' },
    { code : 'BR' , name : 'Brindisi' },
    { code : 'CA' , name : 'Cagliari' },
    { code : 'CL' , name : 'Caltanissetta' },
    { code : 'CB' , name : 'Campobasso' },
    { code : 'CE' , name : 'Caserta' },
    { code : 'CT' , name : 'Catania' },
    { code : 'CZ' , name : 'Catanzaro' },
    { code : 'CH' , name : 'Chieti' },
    { code : 'CO' , name : 'Como' },
    { code : 'CS' , name : 'Cosenza' },
    { code : 'CR' , name : 'Cremona' },
    { code : 'KR' , name : 'Crotone' },
    { code : 'CN' , name : 'Cuneo' },
    { code : 'EN' , name : 'Enna' },
    { code : 'FM' , name : 'Fermo' },
    { code : 'FE' , name : 'Ferrara' },
    { code : 'FI' , name : 'Firenze' },
    { code : 'FG' , name : 'Foggia' },
    { code : 'FC' , name : 'ForlÃ¬-Cesena' },
    { code : 'FR' , name : 'Frosinone' },
    { code : 'GE' , name : 'Genova' },
    { code : 'GO' , name : 'Gorizia' },
    { code : 'GR' , name : 'Grosseto' },
    { code : 'IM' , name : 'Imperia' },
    { code : 'IS' , name : 'Isernia' },
    { code : 'AQ' , name : 'LAquila' },
    { code : 'SP' , name : 'La Spezia' },
    { code : 'LT' , name : 'Latina' },
    { code : 'LE' , name : 'Lecce' },
    { code : 'LC' , name : 'Lecco' },
    { code : 'LI' , name : 'Livorno' },
    { code : 'LO' , name : 'Lodi' },
    { code : 'LU' , name : 'Lucca' },
    { code : 'MC' , name : 'Macerata' },
    { code : 'MN' , name : 'Mantova' },
    { code : 'MS' , name : 'Massa-Carrara' },
    { code : 'MT' , name : 'Matera' },
    { code : 'ME' , name : 'Messina' },
    { code : 'MI' , name : 'Milano' },
    { code : 'MO' , name : 'Modena' },
    { code : 'MB' , name : 'Monza e Brianza' },
    { code : 'NA' , name : 'Napoli' },
    { code : 'NO' , name : 'Novara' },
    { code : 'NU' , name : 'Nuoro' },
    { code : 'OR' , name : 'Oristano' },
    { code : 'PD' , name : 'Padova' },
    { code : 'PA' , name : 'Palermo' },
    { code : 'PR' , name : 'Parma' },
    { code : 'PV' , name : 'Pavia' },
    { code : 'PG' , name : 'Perugia' },
    { code : 'PU' , name : 'Pesaro e Urbino' },
    { code : 'PE' , name : 'Pescara' },
    { code : 'PC' , name : 'Piacenza' },
    { code : 'PI' , name : 'Pisa' },
    { code : 'PT' , name : 'Pistoia' },
    { code : 'PN' , name : 'Pordenone' },
    { code : 'PZ' , name : 'Potenza' },
    { code : 'PO' , name : 'Prato' },
    { code : 'RG' , name : 'Ragusa' },
    { code : 'RA' , name : 'Ravenna' },
    { code : 'RC' , name : 'Reggio Calabria' },
    { code : 'RE' , name : 'Reggio Emilia' },
    { code : 'RI' , name : 'Rieti' },
    { code : 'RN' , name : 'Rimini' },
    { code : 'RM' , name : 'Roma' },
    { code : 'RO' , name : 'Rovigo' },
    { code : 'SA' , name : 'Salerno' },
    { code : 'SS' , name : 'Sassari' },
    { code : 'SV' , name : 'Savona' },
    { code : 'SI' , name : 'Siena' },
    { code : 'SR' , name : 'Siracusa' },
    { code : 'SO' , name : 'Sondrio' },
    { code : 'SU' , name : 'Sud Sardegna' },
    { code : 'TA' , name : 'Taranto' },
    { code : 'TE' , name : 'Teramo' },
    { code : 'TR' , name : 'Terni' },
    { code : 'TO' , name : 'Torino' },
    { code : 'TP' , name : 'Trapani' },
    { code : 'TN' , name : 'Trento' },
    { code : 'TV' , name : 'Treviso' },
    { code : 'TS' , name : 'Trieste' },
    { code : 'UD' , name : 'Udine' },
    { code : 'VA' , name : 'Varese' },
    { code : 'VE' , name : 'Venezia' },
    { code : 'VB' , name : 'Verbano-Cusio-Ossola' },
    { code : 'VC' , name : 'Vercelli' },
    { code : 'VR' , name : 'Verona' },
    { code : 'VV' , name : 'Vibo Valentia' },
    { code : 'VI' , name : 'Vicenza' },
    { code : 'VT' , name : 'Viterbo' },  
  ],

  ES: [  
    { code : 'AG' , name :     'A Coruña' },
    { code : 'AL' , name :     'Álava' },
    { code : 'AN' , name :     'Albacete' },
    { code : 'AO' , name :     'Alicante' },
    { code : 'AR' , name :     'Almería' },
    { code : 'AP' , name :     'Asturias' },
    { code : 'AT' , name :     'Ávila'},
    { code : 'AV' , name :     'Badajoz' },
    { code : 'BA' , name :     'Balears' },
    { code : 'BT' , name :     'Barcelona' },
    { code : 'BL' , name :     'Burgos' },
    { code : 'BN' , name :     'Cáceres' },
    { code : 'BG' , name :     'Cádiz' },
    { code : 'BI' , name :     'Cantabria' },
    { code : 'BO' , name :     'Castellón' },
    { code : 'BZ' , name :     'Ceuta' },
    { code : 'BS' , name :     'Ciudad Real' },
    { code : 'BR' , name :     'Córdoba' },
    { code : 'CA' , name :     'Cuenca' },
    { code : 'CL' , name :     'Girona' },
    { code : 'CB' , name :     'Granada' },
    { code : 'CE' , name :     'Guadalajara' },
    { code : 'CT' , name :     'Guipúzcoa' },
    { code : 'CZ' , name :     'Huelva' },
    { code : 'CH' , name :     'Huesca' },
    { code : 'CO' , name :     'Jaén' },
    { code : 'CS' , name :     'La Rioja' },
    { code : 'CR' , name :     'Las Palmas' },
    { code : 'KR' , name :     'León' },
    { code : 'CN' , name :     'Lleida' },
    { code : 'EN' , name :     'Lugo' },
    { code : 'FM' , name :     'Madrid' },
    { code : 'FE' , name :     'Málaga' },
    { code : 'FI' , name :     'Melilla' },
    { code : 'FG' , name :     'Murcia' },
    { code : 'FC' , name :     'Navarra' },
    { code : 'FR' , name :     'Ourense' },
    { code : 'GE' , name :     'Palencia' },
    { code : 'GO' , name :     'Pontevedra' },
    { code : 'GR' , name :     'Salamanca' },
    { code : 'IM' , name :     'Santa Cruz de Tenerife' },
    { code : 'IS' , name :     'Segovia' },
    { code : 'AQ' , name :     'Sevilla' },
    { code : 'SP' , name :     'Soria' },
    { code : 'LT' , name :     'Tarragona' },
    { code : 'LE' , name :     'Teruel' },
    { code : 'LC' , name :     'Toledo' },
    { code : 'LI' , name :     'Valencia' },
    { code : 'LO' , name :     'Valladolid' },
    { code : 'LU' , name :     'Vizcaya' },
    { code : 'MC' , name :     'Zamora' },
    { code : 'MN' , name :     'Zaragoza' },

  ],
  GB: [
    { code: 'AS', name: 'Aberdeenshire' },
    { code: 'AG', name: 'Anglesey' },
    { code: 'AN', name: 'Angus' },
    { code: 'AM', name: 'Antrim' },
    { code: 'AB', name: 'Argyll and Bute' },
    { code: 'AR', name: 'Armagh' },
    { code: 'AV', name: 'Avon' },
    { code: 'AE', name: 'Ayrshire' },
    { code: 'AF', name: 'Bedfordshire' },
    { code: 'AK', name: 'Berkshire' },
    { code: 'AH', name: 'Brecknockshire' },
    { code: 'BU', name: 'Buckinghamshire' },
    { code: 'CA', name: 'Caernarfonshire' },
    { code: 'CE', name: 'Cambridgeshire' },
    { code: 'CI', name: 'Cambridgeshire and Isle of Ely' },
    { code: 'CG', name: 'Cardiganshire' },
    { code: 'CT', name: 'Carmarthenshire' },
    { code: 'CI', name: 'Cheshire' },
    { code: 'BL', name: 'City of Belfast' },
    { code: 'CS', name: 'City of Bristol' },
    { code: 'DE', name: 'City of Derry' },
    { code: 'MA', name: 'Clackmannanshire' },
    { code: 'CD', name: 'Cleveland' },
    { code: 'CW', name: 'Clwyd' },
    { code: 'CL', name: 'Cornwall' },
    { code: 'UM', name: 'Cumbria' },
    { code: 'DH', name: 'Denbighshire' },
    { code: 'DE', name: 'Derbyshire' },
    { code: 'VO', name: 'Devon' },
    { code: 'ET', name: 'Dorset' },
    { code: 'DO', name: 'Down' },
    { code: 'GA', name: 'Dumfries and Galloway' },
    { code: 'NS', name: 'Dunbartonshire' },
    { code: 'UN', name: 'Dundee' },
    { code: 'AY', name: 'Durham' },
    { code: 'DY', name: 'Dyfed' },
    { code: 'EA', name: 'East Lothian' },
    { code: 'ST', name: 'East Sussex' },
    { code: 'ED', name: 'Edinburgh' },
    { code: 'ES', name: 'Essex' },
    { code: 'FA', name: 'Falkirk' },
    { code: 'FE', name: 'Fermanagh' },
    { code: 'FI', name: 'Fife' },
    { code: 'FL', name: 'Flintshire' },
    { code: 'GL', name: 'Glamorgan' },
    { code: 'GA', name: 'Glasgow' },
    { code: 'GT', name: 'Gloucestershire' },
    { code: 'GR', name: 'Greater Manchester' },
    { code: 'GW', name: 'Gwent' },
    { code: 'GY', name: 'Gwynedd' },
    { code: 'HA', name: 'Hampshire' },
    { code: 'HR', name: 'Harrow' },
    { code: 'HD', name: 'Herefordshire' },
    { code: 'HS', name: 'Hertfordshire' },
    { code: 'HL', name: 'Highland' },
    { code: 'IN', name: 'Inverclyde' },
    { code: 'IS', name: 'Isle of Wight' },
    { code: 'KE', name: 'Kent' },
    { code: 'LA', name: 'Lanarkshire' },
    { code: 'LE', name: 'Lancashire' },
    { code: 'EI', name: 'Leicestershire' },
    { code: 'CO', name: 'Lincolnshire' },
    { code: 'LO', name: 'London' },
    { code: 'RR', name: 'Londonderry' },
    { code: 'ME', name: 'Merionethshire' },
    { code: 'SE', name: 'Merseyside' },
    { code: 'ID', name: 'Mid Glamorgan' },
    { code: 'DD', name: 'Middlesex' },
    { code: 'LO', name: 'Midlothian' },
    { code: 'MO', name: 'Monmouthshire' },
    { code: 'NY', name: 'Montgomeryshire' },
    { code: 'OH', name: 'Moray' },
    { code: 'OK', name: 'Norfolk' },
    { code: 'OR', name: 'North Yorkshire' },
    { code: 'PA', name: 'Northamptonshire' },
    { code: 'RI', name: 'Northumberland' },
    { code: 'SC', name: 'Nottinghamshire' },
    { code: 'SD', name: 'Orkney' },
    { code: 'TN', name: 'Oxfordshire' },
    { code: 'TX', name: 'Pembrokeshire' },
    { code: 'UT', name: 'Perth and Kinross' },
    { code: 'VA', name: 'Powys' },
    { code: 'VT', name: 'Radnorshire' },
    { code: 'WA', name: 'Renfrewshire' },
    { code: 'WI', name: 'Rutland' },
    { code: 'WV', name: 'Scottish Borders' },
    { code: 'WY', name: 'Shetland Isles' },
    { code: 'NC', name: 'Shropshire' },
    { code: 'ND', name: 'Somerset' },
    { code: 'NE', name: 'South Glamorgan' },
    { code: 'NH', name: 'South Yorkshire' },
    { code: 'NJ', name: 'Staffordshire' },
    { code: 'NM', name: 'Stirlingshire' },
    { code: 'NV', name: 'Suffolk' },
    { code: 'NY', name: 'Surrey' },
    { code: 'OH', name: 'Tyne and Wear' },
    { code: 'OK', name: 'Tyrone' },
    { code: 'OR', name: 'Warwickshire' },
    { code: 'PA', name: 'West Glamorgan' },
    { code: 'RI', name: 'West Lothian' },
    { code: 'SC', name: 'West Midlands' },
    { code: 'SD', name: 'West Sussex' },
    { code: 'TN', name: 'West Yorkshire' },
    { code: 'TX', name: 'Western Isles' },
    { code: 'UT', name: 'Wiltshire' },
    { code: 'VA', name: 'Worcestershire' },
    { code: 'VT', name: 'Wrexham' },
    { code: 'WA', name: 'Yorkshire' },
    { code: 'WI', name: 'Yorkshire, East Riding' }
  ]
}
